import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import config from '../config';
import '../css/components/NewsletterRequestForm.css';

interface NewsletterRequestFormProps {
    // Niche is captured silently from whatever search/filter was active —
    // no niche field shown to the user, keeps the form to one input.
    prefillNiche?: string;
}

const NewsletterRequestForm: React.FC<NewsletterRequestFormProps> = ({ prefillNiche }) => {
    const [newsletterName, setNewsletterName] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!newsletterName.trim()) {
            setError('Enter a newsletter name');
            return;
        }

        try {
            setIsSubmitting(true);
            setError(null);
            const token = localStorage.getItem('token');
            await axios.post(
                `${config.backendUrl}sponsors/newsletter-requests`,
                { newsletterName: newsletterName.trim(), niche: (prefillNiche || '').trim() },
                { headers: { 'x-auth-token': token } }
            );
            setSubmitted(true);
            setNewsletterName('');
        } catch (err: any) {
            setError(err.response?.data?.error || 'Failed to submit — try again');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (submitted) {
        return (
            <div className="newsletter-request-form newsletter-request-form--done">
                <FontAwesomeIcon icon={faCheckCircle} />
                <span>Thanks — we'll review it and start tracking its sponsors if it's a fit.</span>
            </div>
        );
    }

    return (
        <form className="newsletter-request-form" onSubmit={handleSubmit}>
            <input
                type="text"
                placeholder="Newsletter name"
                value={newsletterName}
                onChange={(e) => setNewsletterName(e.target.value)}
                maxLength={200}
            />
            <button type="submit" disabled={isSubmitting || !newsletterName.trim()}>
                {isSubmitting ? 'Sending…' : 'Request'}
            </button>
            {error && <span className="newsletter-request-form__error">{error}</span>}
        </form>
    );
};

export default NewsletterRequestForm;
